import { render, staticRenderFns } from "./TextArrayInput.vue?vue&type=template&id=11032778&lang=pug&"
import script from "./TextArrayInput.vue?vue&type=script&lang=js&"
export * from "./TextArrayInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextArrayInput.vue"
export default component.exports